// extracted by mini-css-extract-plugin
module.exports = {"container":"HistoryAppoint_container__3vVFE","header":"HistoryAppoint_header__15Zfj","body":"HistoryAppoint_body__3aGNy","box":"HistoryAppoint_box__3bnqo"};